import MySQL_ABS from "./mysql_components/MySQL_ABS.jsx";
import MySQL_ACOS from "./mysql_components/MySQL_ACOS.jsx";
import MySQL_ADDDATE from "./mysql_components/MySQL_ADDDATE.jsx";
import MySQL_ADDTIME from "./mysql_components/MySQL_ADDTIME.jsx";
import MySQL_ALIASES from "./mysql_components/MySQL_ALIASES.jsx";
import MySQL_ALTERTABLE from "./mysql_components/MySQL_ALTERTABLE.jsx";
import MySQL_ANDORNOT from "./mysql_components/MySQL_ANDORNOT.jsx";
import MySQL_ANYALL from "./mysql_components/MySQL_ANYALL.jsx";
import MySQL_ASCII from "./mysql_components/MySQL_ASCII.jsx";
import MySQL_ASIN from "./mysql_components/MySQL_ASIN.jsx";
import MySQL_ATAN from "./mysql_components/MySQL_ATAN.jsx";
import MySQL_ATAN2 from "./mysql_components/MySQL_ATAN2.jsx";
import MySQL_AUTOINCREMENT from "./mysql_components/MySQL_AUTOINCREMENT.jsx";
import MySQL_AVG from "./mysql_components/MySQL_AVG.jsx";
import MySQL_BETWEEN from "./mysql_components/MySQL_BETWEEN.jsx";
import MySQL_BIN from "./mysql_components/MySQL_BIN.jsx";
import MySQL_BINARY from "./mysql_components/MySQL_BINARY.jsx";
import MySQL_CASE from "./mysql_components/MySQL_CASE.jsx";
import MySQL_CAST from "./mysql_components/MySQL_CAST.jsx";
import MySQL_CEIL from "./mysql_components/MySQL_CEIL.jsx";
import MySQL_CEILING from "./mysql_components/MySQL_CEILING.jsx";
import MySQL_CERTIFICATE from "./mysql_components/MySQL_CERTIFICATE.jsx";
import MySQL_CHARACTER_LENGTH from "./mysql_components/MySQL_CHARACTER_LENGTH.jsx";
import MySQL_CHAR_LENGTH from "./mysql_components/MySQL_CHAR_LENGTH.jsx";
import MySQL_CHECK from "./mysql_components/MySQL_CHECK.jsx";
import MySQL_COALESCE from "./mysql_components/MySQL_COALESCE.jsx";
import MySQL_COMMENTS from "./mysql_components/MySQL_COMMENTS.jsx";
import MySQL_CONCAT from "./mysql_components/MySQL_CONCAT.jsx";
import MySQL_CONCAT_WS from "./mysql_components/MySQL_CONCAT_WS.jsx";
import MySQL_CONNECTION_ID from "./mysql_components/MySQL_CONNECTION_ID.jsx";
import MySQL_CONSTRAINTS from "./mysql_components/MySQL_CONSTRAINTS.jsx";
import MySQL_CONV from "./mysql_components/MySQL_CONV.jsx";
import MySQL_CONVERT from "./mysql_components/MySQL_CONVERT.jsx";
import MySQL_COS from "./mysql_components/MySQL_COS.jsx";
import MySQL_COT from "./mysql_components/MySQL_COT.jsx";
import MySQL_COUNT from "./mysql_components/MySQL_COUNT.jsx";
import MySQL_COUNTAVG from "./mysql_components/MySQL_COUNTAVG.jsx";
import MySQL_CREATEDB from "./mysql_components/MySQL_CREATEDB.jsx";
import MySQL_CREATEINDEX from "./mysql_components/MySQL_CREATEINDEX.jsx";
import MySQL_CREATETABLE from "./mysql_components/MySQL_CREATETABLE.jsx";
import MySQL_CROSSJOIN from "./mysql_components/MySQL_CROSSJOIN.jsx";
import MySQL_CURDATE from "./mysql_components/MySQL_CURDATE.jsx";
import MySQL_CURRENT_DATE from "./mysql_components/MySQL_CURRENT_DATE.jsx";
import MySQL_CURRENT_TIME from "./mysql_components/MySQL_CURRENT_TIME.jsx";
import MySQL_CURRENT_TIMESTAMP from "./mysql_components/MySQL_CURRENT_TIMESTAMP.jsx";
import MySQL_CURRENT_USER from "./mysql_components/MySQL_CURRENT_USER.jsx";
import MySQL_CURTIME from "./mysql_components/MySQL_CURTIME.jsx";
import MySQL_DATABASE from "./mysql_components/MySQL_DATABASE.jsx";
import MySQL_DATATYPES from "./mysql_components/MySQL_DATATYPES.jsx";
import MySQL_DATE from "./mysql_components/MySQL_DATE.jsx";
import MySQL_DATEDIFF from "./mysql_components/MySQL_DATEDIFF.jsx";
import MySQL_DATES from "./mysql_components/MySQL_DATES.jsx";
import MySQL_DATE_ADD from "./mysql_components/MySQL_DATE_ADD.jsx";
import MySQL_DATE_FORMAT from "./mysql_components/MySQL_DATE_FORMAT.jsx";
import MySQL_DATE_SUB from "./mysql_components/MySQL_DATE_SUB.jsx";
import MySQL_DAY from "./mysql_components/MySQL_DAY.jsx";
import MySQL_DAYNAME from "./mysql_components/MySQL_DAYNAME.jsx";
import MySQL_DAYOFMONTH from "./mysql_components/MySQL_DAYOFMONTH.jsx";
import MySQL_DAYOFWEEK from "./mysql_components/MySQL_DAYOFWEEK.jsx";
import MySQL_DAYOFYEAR from "./mysql_components/MySQL_DAYOFYEAR.jsx";
import MySQL_DEFAULT from "./mysql_components/MySQL_DEFAULT.jsx";
import MySQL_DEGREES from "./mysql_components/MySQL_DEGREES.jsx";
import MySQL_DELETE from "./mysql_components/MySQL_DELETE.jsx";
import MySQL_DIV from "./mysql_components/MySQL_DIV.jsx";
import MySQL_DROPDB from "./mysql_components/MySQL_DROPDB.jsx";
import MySQL_DROPTABLE from "./mysql_components/MySQL_DROPTABLE.jsx";
import MySQL_EDITOR from "./mysql_components/MySQL_EDITOR.jsx";
import MySQL_EXAMPLES from "./mysql_components/MySQL_EXAMPLES.jsx";
import MySQL_EXERCISES from "./mysql_components/MySQL_EXERCISES.jsx";
import MySQL_EXISTS from "./mysql_components/MySQL_EXISTS.jsx";
import MySQL_EXP from "./mysql_components/MySQL_EXP.jsx";
import MySQL_EXTRACT from "./mysql_components/MySQL_EXTRACT.jsx";
import MySQL_FIELD from "./mysql_components/MySQL_FIELD.jsx";
import MySQL_FIND_IN_SET from "./mysql_components/MySQL_FIND_IN_SET.jsx";
import MySQL_FLOOR from "./mysql_components/MySQL_FLOOR.jsx";
import MySQL_FOREIGNKEY from "./mysql_components/MySQL_FOREIGNKEY.jsx";
import MySQL_FORMAT from "./mysql_components/MySQL_FORMAT.jsx";
import MySQL_FROM_DAYS from "./mysql_components/MySQL_FROM_DAYS.jsx";
import MySQL_GREATEST from "./mysql_components/MySQL_GREATEST.jsx";
import MySQL_GROUPBY from "./mysql_components/MySQL_GROUPBY.jsx";
import MySQL_HAVING from "./mysql_components/MySQL_HAVING.jsx";
import MySQL_Home from "./mysql_components/MySQL_Home.jsx";
import MySQL_HOUR from "./mysql_components/MySQL_HOUR.jsx";
import MySQL_IF from "./mysql_components/MySQL_IF.jsx";
import MySQL_IFNULL from "./mysql_components/MySQL_IFNULL.jsx";
import MySQL_IN from "./mysql_components/MySQL_IN.jsx";
import MySQL_INNERJOIN from "./mysql_components/MySQL_INNERJOIN.jsx";
import MySQL_INSERT from "./mysql_components/MySQL_INSERT.jsx";
import MySQL_INSERTINTO from "./mysql_components/MySQL_INSERTINTO.jsx";
import MySQL_INSERTSELECT from "./mysql_components/MySQL_INSERTSELECT.jsx";
import MySQL_INSTR from "./mysql_components/MySQL_INSTR.jsx";
import MySQL_Intro from "./mysql_components/MySQL_Intro.jsx";
import MySQL_ISNULL from "./mysql_components/MySQL_ISNULL.jsx";
import MySQL_JOINS from "./mysql_components/MySQL_JOINS.jsx";
import MySQL_LAST_DAY from "./mysql_components/MySQL_LAST_DAY.jsx";
import MySQL_LAST_INSERT_ID from "./mysql_components/MySQL_LAST_INSERT_ID.jsx";
import MySQL_LCASE from "./mysql_components/MySQL_LCASE.jsx";
import MySQL_LEAST from "./mysql_components/MySQL_LEAST.jsx";
import MySQL_LEFT from "./mysql_components/MySQL_LEFT.jsx";
import MySQL_LEFTJOIN from "./mysql_components/MySQL_LEFTJOIN.jsx";
import MySQL_LENGTH from "./mysql_components/MySQL_LENGTH.jsx";
import MySQL_LIKE from "./mysql_components/MySQL_LIKE.jsx";
import MySQL_LIMIT from "./mysql_components/MySQL_LIMIT.jsx";
import MySQL_LN from "./mysql_components/MySQL_LN.jsx";
import MySQL_LOCALTIME from "./mysql_components/MySQL_LOCALTIME.jsx";
import MySQL_LOCALTIMESTAMP from "./mysql_components/MySQL_LOCALTIMESTAMP.jsx";
import MySQL_LOCATE from "./mysql_components/MySQL_LOCATE.jsx";
import MySQL_LOG from "./mysql_components/MySQL_LOG.jsx";
import MySQL_LOG10 from "./mysql_components/MySQL_LOG10.jsx";
import MySQL_LOG2 from "./mysql_components/MySQL_LOG2.jsx";
import MySQL_LOWER from "./mysql_components/MySQL_LOWER.jsx";
import MySQL_LPAD from "./mysql_components/MySQL_LPAD.jsx";
import MySQL_LTRIM from "./mysql_components/MySQL_LTRIM.jsx";
import MySQL_MAKEDATE from "./mysql_components/MySQL_MAKEDATE.jsx";
import MySQL_MAKETIME from "./mysql_components/MySQL_MAKETIME.jsx";
import MySQL_MAX from "./mysql_components/MySQL_MAX.jsx";
import MySQL_MICROSECOND from "./mysql_components/MySQL_MICROSECOND.jsx";
import MySQL_MID from "./mysql_components/MySQL_MID.jsx";
import MySQL_MIN from "./mysql_components/MySQL_MIN.jsx";
import MySQL_MINMAX from "./mysql_components/MySQL_MINMAX.jsx";
import MySQL_MINUTE from "./mysql_components/MySQL_MINUTE.jsx";
import MySQL_MOD from "./mysql_components/MySQL_MOD.jsx";
import MySQL_MONTH from "./mysql_components/MySQL_MONTH.jsx";
import MySQL_MONTHNAME from "./mysql_components/MySQL_MONTHNAME.jsx";
import MySQL_NOTNULL from "./mysql_components/MySQL_NOTNULL.jsx";
import MySQL_NOW from "./mysql_components/MySQL_NOW.jsx";
import MySQL_NULL from "./mysql_components/MySQL_NULL.jsx";
import MySQL_NULLFUNCTIONS from "./mysql_components/MySQL_NULLFUNCTIONS.jsx";
import MySQL_NULLIF from "./mysql_components/MySQL_NULLIF.jsx";
import MySQL_OPERATORS from "./mysql_components/MySQL_OPERATORS.jsx";
import MySQL_ORDERBY from "./mysql_components/MySQL_ORDERBY.jsx";
import MySQL_PERIOD_ADD from "./mysql_components/MySQL_PERIOD_ADD.jsx";
import MySQL_PERIOD_DIFF from "./mysql_components/MySQL_PERIOD_DIFF.jsx";
import MySQL_PI from "./mysql_components/MySQL_PI.jsx";
import MySQL_POSITION from "./mysql_components/MySQL_POSITION.jsx";
import MySQL_POW from "./mysql_components/MySQL_POW.jsx";
import MySQL_POWER from "./mysql_components/MySQL_POWER.jsx";
import MySQL_PRIMARYKEY from "./mysql_components/MySQL_PRIMARYKEY.jsx";
import MySQL_QUARTER from "./mysql_components/MySQL_QUARTER.jsx";
import MySQL_QUIZ from "./mysql_components/MySQL_QUIZ.jsx";
import MySQL_RADIANS from "./mysql_components/MySQL_RADIANS.jsx";
import MySQL_RAND from "./mysql_components/MySQL_RAND.jsx";
import MySQL_RDBMS from "./mysql_components/MySQL_RDBMS.jsx";
import MySQL_REPEAT from "./mysql_components/MySQL_REPEAT.jsx";
import MySQL_REPLACE from "./mysql_components/MySQL_REPLACE.jsx";
import MySQL_REVERSE from "./mysql_components/MySQL_REVERSE.jsx";
import MySQL_RIGHT from "./mysql_components/MySQL_RIGHT.jsx";
import MySQL_RIGHTJOIN from "./mysql_components/MySQL_RIGHTJOIN.jsx";
import MySQL_ROUND from "./mysql_components/MySQL_ROUND.jsx";
import MySQL_RPAD from "./mysql_components/MySQL_RPAD.jsx";
import MySQL_RTRIM from "./mysql_components/MySQL_RTRIM.jsx";
import MySQL_SECOND from "./mysql_components/MySQL_SECOND.jsx";
import MySQL_SEC_TO_TIME from "./mysql_components/MySQL_SEC_TO_TIME.jsx";
import MySQL_SELECT from "./mysql_components/MySQL_SELECT.jsx";
import MySQL_SELFJOIN from "./mysql_components/MySQL_SELFJOIN.jsx";
import MySQL_SESSION_USER from "./mysql_components/MySQL_SESSION_USER.jsx";
import MySQL_SIGN from "./mysql_components/MySQL_SIGN.jsx";
import MySQL_SIN from "./mysql_components/MySQL_SIN.jsx";
import MySQL_SPACE from "./mysql_components/MySQL_SPACE.jsx";
import MySQL_SQL from "./mysql_components/MySQL_SQL.jsx";
import MySQL_SQRT from "./mysql_components/MySQL_SQRT.jsx";
import MySQL_STRCMP from "./mysql_components/MySQL_STRCMP.jsx";
import MySQL_STR_TO_DATE from "./mysql_components/MySQL_STR_TO_DATE.jsx";
import MySQL_STUDYPLAN from "./mysql_components/MySQL_STUDYPLAN.jsx";
import MySQL_SUBDATE from "./mysql_components/MySQL_SUBDATE.jsx";
import MySQL_SUBSTR from "./mysql_components/MySQL_SUBSTR.jsx";
import MySQL_SUBSTRING from "./mysql_components/MySQL_SUBSTRING.jsx";
import MySQL_SUBSTRING_INDEX from "./mysql_components/MySQL_SUBSTRING_INDEX.jsx";
import MySQL_SUBTIME from "./mysql_components/MySQL_SUBTIME.jsx";
import MySQL_SUM from "./mysql_components/MySQL_SUM.jsx";
import MySQL_SYLLABUS from "./mysql_components/MySQL_SYLLABUS.jsx";
import MySQL_SYSDATE from "./mysql_components/MySQL_SYSDATE.jsx";
import MySQL_SYSTEM_USER from "./mysql_components/MySQL_SYSTEM_USER.jsx";
import MySQL_TAN from "./mysql_components/MySQL_TAN.jsx";
import MySQL_TIME from "./mysql_components/MySQL_TIME.jsx";
import MySQL_TIMEDIFF from "./mysql_components/MySQL_TIMEDIFF.jsx";
import MySQL_TIMESTAMP from "./mysql_components/MySQL_TIMESTAMP.jsx";
import MySQL_TIME_FORMAT from "./mysql_components/MySQL_TIME_FORMAT.jsx";
import MySQL_TIME_TO_SEC from "./mysql_components/MySQL_TIME_TO_SEC.jsx";
import MySQL_TO_DAYS from "./mysql_components/MySQL_TO_DAYS.jsx";
import MySQL_TRIM from "./mysql_components/MySQL_TRIM.jsx";
import MySQL_TRUNCATE from "./mysql_components/MySQL_TRUNCATE.jsx";
import MySQL_UCASE from "./mysql_components/MySQL_UCASE.jsx";
import MySQL_UNION from "./mysql_components/MySQL_UNION.jsx";
import MySQL_UNIONALL from "./mysql_components/MySQL_UNIONALL.jsx";
import MySQL_UNIQUE from "./mysql_components/MySQL_UNIQUE.jsx";
import MySQL_UPDATE from "./mysql_components/MySQL_UPDATE.jsx";
import MySQL_UPPER from "./mysql_components/MySQL_UPPER.jsx";
import MySQL_USER from "./mysql_components/MySQL_USER.jsx";
import MySQL_VERSION from "./mysql_components/MySQL_VERSION.jsx";
import MySQL_VIEWS from "./mysql_components/MySQL_VIEWS.jsx";
import MySQL_WEEK from "./mysql_components/MySQL_WEEK.jsx";
import MySQL_WEEKDAY from "./mysql_components/MySQL_WEEKDAY.jsx";
import MySQL_WEEKOFYEAR from "./mysql_components/MySQL_WEEKOFYEAR.jsx";
import MySQL_WHERE from "./mysql_components/MySQL_WHERE.jsx";
import MySQL_WILDCARDS from "./mysql_components/MySQL_WILDCARDS.jsx";
import MySQL_YEAR from "./mysql_components/MySQL_YEAR.jsx";
import MySQL_YEARWEEK from "./mysql_components/MySQL_YEARWEEK.jsx";

const MySQLComponentsMap = {
  "<MySQL_ABS />": MySQL_ABS,
  "<MySQL_ACOS />": MySQL_ACOS,
  "<MySQL_ADDDATE />": MySQL_ADDDATE,
  "<MySQL_ADDTIME />": MySQL_ADDTIME,
  "<MySQL_ALIASES />": MySQL_ALIASES,
  "<MySQL_ALTERTABLE />": MySQL_ALTERTABLE,
  "<MySQL_ANDORNOT />": MySQL_ANDORNOT,
  "<MySQL_ANYALL />": MySQL_ANYALL,
  "<MySQL_ASCII />": MySQL_ASCII,
  "<MySQL_ASIN />": MySQL_ASIN,
  "<MySQL_ATAN />": MySQL_ATAN,
  "<MySQL_ATAN2 />": MySQL_ATAN2,
  "<MySQL_AUTOINCREMENT />": MySQL_AUTOINCREMENT,
  "<MySQL_AVG />": MySQL_AVG,
  "<MySQL_BETWEEN />": MySQL_BETWEEN,
  "<MySQL_BIN />": MySQL_BIN,
  "<MySQL_BINARY />": MySQL_BINARY,
  "<MySQL_CASE />": MySQL_CASE,
  "<MySQL_CAST />": MySQL_CAST,
  "<MySQL_CEIL />": MySQL_CEIL,
  "<MySQL_CEILING />": MySQL_CEILING,
  "<MySQL_CERTIFICATE />": MySQL_CERTIFICATE,
  "<MySQL_CHARACTER_LENGTH />": MySQL_CHARACTER_LENGTH,
  "<MySQL_CHAR_LENGTH />": MySQL_CHAR_LENGTH,
  "<MySQL_CHECK />": MySQL_CHECK,
  "<MySQL_COALESCE />": MySQL_COALESCE,
  "<MySQL_COMMENTS />": MySQL_COMMENTS,
  "<MySQL_CONCAT />": MySQL_CONCAT,
  "<MySQL_CONCAT_WS />": MySQL_CONCAT_WS,
  "<MySQL_CONNECTION_ID />": MySQL_CONNECTION_ID,
  "<MySQL_CONSTRAINTS />": MySQL_CONSTRAINTS,
  "<MySQL_CONV />": MySQL_CONV,
  "<MySQL_CONVERT />": MySQL_CONVERT,
  "<MySQL_COS />": MySQL_COS,
  "<MySQL_COT />": MySQL_COT,
  "<MySQL_COUNT />": MySQL_COUNT,
  "<MySQL_COUNTAVG />": MySQL_COUNTAVG,
  "<MySQL_CREATEDB />": MySQL_CREATEDB,
  "<MySQL_CREATEINDEX />": MySQL_CREATEINDEX,
  "<MySQL_CREATETABLE />": MySQL_CREATETABLE,
  "<MySQL_CROSSJOIN />": MySQL_CROSSJOIN,
  "<MySQL_CURDATE />": MySQL_CURDATE,
  "<MySQL_CURRENT_DATE />": MySQL_CURRENT_DATE,
  "<MySQL_CURRENT_TIME />": MySQL_CURRENT_TIME,
  "<MySQL_CURRENT_TIMESTAMP />": MySQL_CURRENT_TIMESTAMP,
  "<MySQL_CURRENT_USER />": MySQL_CURRENT_USER,
  "<MySQL_CURTIME />": MySQL_CURTIME,
  "<MySQL_DATABASE />": MySQL_DATABASE,
  "<MySQL_DATATYPES />": MySQL_DATATYPES,
  "<MySQL_DATE />": MySQL_DATE,
  "<MySQL_DATEDIFF />": MySQL_DATEDIFF,
  "<MySQL_DATES />": MySQL_DATES,
  "<MySQL_DATE_ADD />": MySQL_DATE_ADD,
  "<MySQL_DATE_FORMAT />": MySQL_DATE_FORMAT,
  "<MySQL_DATE_SUB />": MySQL_DATE_SUB,
  "<MySQL_DAY />": MySQL_DAY,
  "<MySQL_DAYNAME />": MySQL_DAYNAME,
  "<MySQL_DAYOFMONTH />": MySQL_DAYOFMONTH,
  "<MySQL_DAYOFWEEK />": MySQL_DAYOFWEEK,
  "<MySQL_DAYOFYEAR />": MySQL_DAYOFYEAR,
  "<MySQL_DEFAULT />": MySQL_DEFAULT,
  "<MySQL_DEGREES />": MySQL_DEGREES,
  "<MySQL_DELETE />": MySQL_DELETE,
  "<MySQL_DIV />": MySQL_DIV,
  "<MySQL_DROPDB />": MySQL_DROPDB,
  "<MySQL_DROPTABLE />": MySQL_DROPTABLE,
  "<MySQL_EDITOR />": MySQL_EDITOR,
  "<MySQL_EXAMPLES />": MySQL_EXAMPLES,
  "<MySQL_EXERCISES />": MySQL_EXERCISES,
  "<MySQL_EXISTS />": MySQL_EXISTS,
  "<MySQL_EXP />": MySQL_EXP,
  "<MySQL_EXTRACT />": MySQL_EXTRACT,
  "<MySQL_FIELD />": MySQL_FIELD,
  "<MySQL_FIND_IN_SET />": MySQL_FIND_IN_SET,
  "<MySQL_FLOOR />": MySQL_FLOOR,
  "<MySQL_FOREIGNKEY />": MySQL_FOREIGNKEY,
  "<MySQL_FORMAT />": MySQL_FORMAT,
  "<MySQL_FROM_DAYS />": MySQL_FROM_DAYS,
  "<MySQL_GREATEST />": MySQL_GREATEST,
  "<MySQL_GROUPBY />": MySQL_GROUPBY,
  "<MySQL_HAVING />": MySQL_HAVING,
  "<MySQL_Home />": MySQL_Home,
  "<MySQL_HOUR />": MySQL_HOUR,
  "<MySQL_IF />": MySQL_IF,
  "<MySQL_IFNULL />": MySQL_IFNULL,
  "<MySQL_IN />": MySQL_IN,
  "<MySQL_INNERJOIN />": MySQL_INNERJOIN,
  "<MySQL_INSERT />": MySQL_INSERT,
  "<MySQL_INSERTINTO />": MySQL_INSERTINTO,
  "<MySQL_INSERTSELECT />": MySQL_INSERTSELECT,
  "<MySQL_INSTR />": MySQL_INSTR,
  "<MySQL_Intro />": MySQL_Intro,
  "<MySQL_ISNULL />": MySQL_ISNULL,
  "<MySQL_JOINS />": MySQL_JOINS,
  "<MySQL_LAST_DAY />": MySQL_LAST_DAY,
  "<MySQL_LAST_INSERT_ID />": MySQL_LAST_INSERT_ID,
  "<MySQL_LCASE />": MySQL_LCASE,
  "<MySQL_LEAST />": MySQL_LEAST,
  "<MySQL_LEFT />": MySQL_LEFT,
  "<MySQL_LEFTJOIN />": MySQL_LEFTJOIN,
  "<MySQL_LENGTH />": MySQL_LENGTH,
  "<MySQL_LIKE />": MySQL_LIKE,
  "<MySQL_LIMIT />": MySQL_LIMIT,
  "<MySQL_LN />": MySQL_LN,
  "<MySQL_LOCALTIME />": MySQL_LOCALTIME,
  "<MySQL_LOCALTIMESTAMP />": MySQL_LOCALTIMESTAMP,
  "<MySQL_LOCATE />": MySQL_LOCATE,
  "<MySQL_LOG />": MySQL_LOG,
  "<MySQL_LOG10 />": MySQL_LOG10,
  "<MySQL_LOG2 />": MySQL_LOG2,
  "<MySQL_LOWER />": MySQL_LOWER,
  "<MySQL_LPAD />": MySQL_LPAD,
  "<MySQL_LTRIM />": MySQL_LTRIM,
  "<MySQL_MAKEDATE />": MySQL_MAKEDATE,
  "<MySQL_MAKETIME />": MySQL_MAKETIME,
  "<MySQL_MAX />": MySQL_MAX,
  "<MySQL_MICROSECOND />": MySQL_MICROSECOND,
  "<MySQL_MID />": MySQL_MID,
  "<MySQL_MIN />": MySQL_MIN,
  "<MySQL_MINMAX />": MySQL_MINMAX,
  "<MySQL_MINUTE />": MySQL_MINUTE,
  "<MySQL_MOD />": MySQL_MOD,
  "<MySQL_MONTH />": MySQL_MONTH,
  "<MySQL_MONTHNAME />": MySQL_MONTHNAME,
  "<MySQL_NOTNULL />": MySQL_NOTNULL,
  "<MySQL_NOW />": MySQL_NOW,
  "<MySQL_NULL />": MySQL_NULL,
  "<MySQL_NULLFUNCTIONS />": MySQL_NULLFUNCTIONS,
  "<MySQL_NULLIF />": MySQL_NULLIF,
  "<MySQL_OPERATORS />": MySQL_OPERATORS,
  "<MySQL_ORDERBY />": MySQL_ORDERBY,
  "<MySQL_PERIOD_ADD />": MySQL_PERIOD_ADD,
  "<MySQL_PERIOD_DIFF />": MySQL_PERIOD_DIFF,
  "<MySQL_PI />": MySQL_PI,
  "<MySQL_POSITION />": MySQL_POSITION,
  "<MySQL_POW />": MySQL_POW,
  "<MySQL_POWER />": MySQL_POWER,
  "<MySQL_PRIMARYKEY />": MySQL_PRIMARYKEY,
  "<MySQL_QUARTER />": MySQL_QUARTER,
  "<MySQL_QUIZ />": MySQL_QUIZ,
  "<MySQL_RADIANS />": MySQL_RADIANS,
  "<MySQL_RAND />": MySQL_RAND,
  "<MySQL_RDBMS />": MySQL_RDBMS,
  "<MySQL_REPEAT />": MySQL_REPEAT,
  "<MySQL_REPLACE />": MySQL_REPLACE,
  "<MySQL_REVERSE />": MySQL_REVERSE,
  "<MySQL_RIGHT />": MySQL_RIGHT,
  "<MySQL_RIGHTJOIN />": MySQL_RIGHTJOIN,
  "<MySQL_ROUND />": MySQL_ROUND,
  "<MySQL_RPAD />": MySQL_RPAD,
  "<MySQL_RTRIM />": MySQL_RTRIM,
  "<MySQL_SECOND />": MySQL_SECOND,
  "<MySQL_SEC_TO_TIME />": MySQL_SEC_TO_TIME,
  "<MySQL_SELECT />": MySQL_SELECT,
  "<MySQL_SELFJOIN />": MySQL_SELFJOIN,
  "<MySQL_SESSION_USER />": MySQL_SESSION_USER,
  "<MySQL_SIGN />": MySQL_SIGN,
  "<MySQL_SIN />": MySQL_SIN,
  "<MySQL_SPACE />": MySQL_SPACE,
  "<MySQL_SQL />": MySQL_SQL,
  "<MySQL_SQRT />": MySQL_SQRT,
  "<MySQL_STRCMP />": MySQL_STRCMP,
  "<MySQL_STR_TO_DATE />": MySQL_STR_TO_DATE,
  "<MySQL_STUDYPLAN />": MySQL_STUDYPLAN,
  "<MySQL_SUBDATE />": MySQL_SUBDATE,
  "<MySQL_SUBSTR />": MySQL_SUBSTR,
  "<MySQL_SUBSTRING />": MySQL_SUBSTRING,
  "<MySQL_SUBSTRING_INDEX />": MySQL_SUBSTRING_INDEX,
  "<MySQL_SUBTIME />": MySQL_SUBTIME,
  "<MySQL_SUM />": MySQL_SUM,
  "<MySQL_SYLLABUS />": MySQL_SYLLABUS,
  "<MySQL_SYSDATE />": MySQL_SYSDATE,
  "<MySQL_SYSTEM_USER />": MySQL_SYSTEM_USER,
  "<MySQL_TAN />": MySQL_TAN,
  "<MySQL_TIME />": MySQL_TIME,
  "<MySQL_TIMEDIFF />": MySQL_TIMEDIFF,
  "<MySQL_TIMESTAMP />": MySQL_TIMESTAMP,
  "<MySQL_TIME_FORMAT />": MySQL_TIME_FORMAT,
  "<MySQL_TIME_TO_SEC />": MySQL_TIME_TO_SEC,
  "<MySQL_TO_DAYS />": MySQL_TO_DAYS,
  "<MySQL_TRIM />": MySQL_TRIM,
  "<MySQL_TRUNCATE />": MySQL_TRUNCATE,
  "<MySQL_UCASE />": MySQL_UCASE,
  "<MySQL_UNION />": MySQL_UNION,
  "<MySQL_UNIONALL />": MySQL_UNIONALL,
  "<MySQL_UNIQUE />": MySQL_UNIQUE,
  "<MySQL_UPDATE />": MySQL_UPDATE,
  "<MySQL_UPPER />": MySQL_UPPER,
  "<MySQL_USER />": MySQL_USER,
  "<MySQL_VERSION />": MySQL_VERSION,
  "<MySQL_VIEWS />": MySQL_VIEWS,
  "<MySQL_WEEK />": MySQL_WEEK,
  "<MySQL_WEEKDAY />": MySQL_WEEKDAY,
  "<MySQL_WEEKOFYEAR />": MySQL_WEEKOFYEAR,
  "<MySQL_WHERE />": MySQL_WHERE,
  "<MySQL_WILDCARDS />": MySQL_WILDCARDS,
  "<MySQL_YEAR />": MySQL_YEAR,
  "<MySQL_YEARWEEK />": MySQL_YEARWEEK,
};

export default MySQLComponentsMap;
